export default {
  home: {
    title: "Prenez contact avec nos équipes",
    subtitle:
      "Sélectionnez votre besoin pour réserver un créneau en visio-conférence.",
    "get-in-touch": "Prendre contact",
    "support-card": {
      "start-solar-autonomy": {
        name: "Démarrer autonomie solaire",
        description:
          "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
      },
      "for-industry-farmers": {
        name: "Pour industriels & agriculteurs",
        description:
          "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe technico-administrative.",
      },
      "for-photovoltaic-professionals": {
        name: "Pour artisans photovoltaïques",
        description:
          "Besoin de précisions sur nos solutions informatiques ? Prenez contact en tant que professionnel photovoltaïque.",
      },
      "technical-support": {
        name: "Accompagnement",
        description:
          "Besoin d'aide ou bien envie de découvrir toutes les fonctionnalités sur votre compte ? Prenez contact avec notre équipe technique.",
      },
      "solar-partnerships": {
        name: "Partenariats solaires",
        description:
          "Vous recherchez des opportunitées de partenariat entre l'informatique et le photovoltaïque ? Prenez contact !",
      },
      press: {
        name: "Presse",
        description:
          "Besoin de nous joindre ? Prenez contact avec notre relation presse pour mettre en valeur les technologies propres.",
      },
    },
  },
  "our-office": {
    title: "Venez-nous rendre visite !",
    subtitle:
      "Implantées au Vieux-Port de Marseille, nous avons opté pour un QG dans un ancien atelier d'art, à coté du Mémorial de la Marseillaise, afin de contribuer à la régénération du quartier.",
    location: {
      region: "Provence",
      address: "11 rue Thubaneau, 13001 Marseille, France"
    },
    maps: "Afficher dans Maps"
  },
  "help-center": {
    title: "Consultez notre centre d'aide pour plus d'informations",
    subtitle:
      "Nous disposons de nombreux guides qui peuvent vous aider à résoudre votre question.",
  },
  schedule: {
    "chat-online": "Vous préférez discuter directement avec nous en ligne ?",
    "open-chatbox": "Ouvrir messagerie",
    residential: {
      heading: "Pour particuliers",
      description:
        "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
      breadcrumb: {
        name: "Démarrer son autonomie solaire",
      },
    },
    business: {
      heading: "Pour industriels & agriculteurs",
      description:
        "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe au service des installateurs photovoltaïques.",
      breadcrumb: {
        name: "Pour industriels & agriculteurs",
      },
    },
    installer: {
      heading: "Pour installateurs photovoltaïques",
      description:
        "Besoin de précisions sur nos solutions informatiques ? Prenez contact avec notre équipe technico-administrative pour professionnels.",
      breadcrumb: {
        name: "Pour installateurs photovoltaïques",
      },
    },
    "technical-support": {
      heading: "Accompagnement",
      description:
        "Besoin d'aide ou bien envie de découvrir toutes les fonctionnalités sur votre compte ? Prenez contact avec notre équipe technique.",
      breadcrumb: {
        name: "Accompagnement",
      },
    },
    partnerships: {
      heading: "Partenariats solaires",
      description:
        "Vous recherchez des solutions informatiques pour le domaine photovoltaïque ? Prenez contact pour des opportunitées de partenariat.",
      breadcrumb: {
        name: "Partenariats solaires",
      },
    },
    press: {
      heading: "Presse",
      description:
        "Besoin de nous joindre ? Prenez contact avec notre relation presse.",
      breadcrumb: {
        name: "Presse",
      },
    },
  },
}
